// let scrollCount = 0;
// const baseWidth = 200;
// const baseHeight = 100;
// const baseScale = 1;
// const scaleStep = 0.2; // scale increase per scrollCount
// const sizeStep = 50; // step in px for width/height change
// const maxWidth = 450; // max width for logo

// // Mobile settings
// const isMobile = window.matchMedia("(max-width: 768px)").matches;
// const maxMobileWidth = 250;
// const maxMobileHeight = 125;
// const maxScale = 1.5;

// // Calculate maxScrollCount dynamically
// const maxScrollCount = Math.floor((maxWidth - baseWidth) / sizeStep);

// // Flag to track the first scroll event
// let firstScroll = true;

// // Set logo size function (with scaling based on scroll count)
// function setLogoSize(logo, step) {
//     let newWidth = baseWidth + step * sizeStep;
//     let newHeight = baseHeight + step * (sizeStep / 2);
//     let newScale = baseScale + step * scaleStep;

//     // Apply limits for mobile
//     if (isMobile) {
//         newWidth = Math.min(newWidth, maxMobileWidth);
//         newHeight = Math.min(newHeight, maxMobileHeight);
//         newScale = Math.min(newScale, maxScale);
//     }

//     // Apply maximum width limit
//     newWidth = Math.min(newWidth, maxWidth);

//     // Smooth transition: width, height, and scale
//     logo.style.transition = 'width 0.3s ease, height 0.3s ease, transform 0.3s ease';
//     logo.style.width = `${newWidth}px`;
//     logo.style.height = `${newHeight}px`;
//     logo.style.transform = `scale(${newScale})`;
// }

// // Smooth shrink effect based on scroll
// function smoothShrink(logo, scrollTop) {
//     const maxShrinkDistance = 500;
//     let factor = Math.min(scrollTop / maxShrinkDistance, 1);

//     let targetWidth = baseWidth + scrollCount * sizeStep;
//     let targetHeight = baseHeight + scrollCount * (sizeStep / 2);
//     let targetScale = baseScale + scrollCount * scaleStep;

//     // Gradual shrink based on scroll position (smooth)
//     let newWidth = targetWidth - (targetWidth - baseWidth) * factor;
//     let newHeight = targetHeight - (targetHeight - baseHeight) * factor;
//     let newScale = targetScale - (targetScale - baseScale) * factor;

//     if (isMobile) {
//         newWidth = Math.min(newWidth, maxMobileWidth);
//         newHeight = Math.min(newHeight, maxMobileHeight);
//         newScale = Math.min(newScale, maxScale);
//     }

//     newWidth = Math.min(newWidth, maxWidth);

//     // Apply smooth transition
//     logo.style.transition = 'width 0.2s ease, height 0.2s ease, transform 0.2s ease';
//     logo.style.width = `${newWidth}px`;
//     logo.style.height = `${newHeight}px`;
//     logo.style.transform = `scale(${newScale})`;
// }

// // Initialize logos to base size (only on page load)
// function initLogos() {
//     const logos = document.querySelectorAll(".large_logo_new");
//     logos.forEach(logo => {
//         // Set the logo to the base size initially (without scrolling)
//         logo.style.width = `${baseWidth}px`;
//         logo.style.height = `${baseHeight}px`;
//         logo.style.transform = `scale(${baseScale})`;
//     });
// }

// // Call initLogos once on page load to set the initial state
// initLogos();

// // Scroll event to smooth shrink logo
// // Scroll event to smooth shrink logo
// function smoothShrinkMobile(logo, scrollTop) {
//     const maxScrollDistance = 500;
//     let factor = Math.min(scrollTop / maxScrollDistance, 1);

//     const maxWidthMobile = 164;
//     const maxHeightMobile = 84;
//     const maxScaleMobile = 2;

//     let newWidth = baseWidth + (maxWidthMobile - baseWidth) * factor;
//     let newHeight = baseHeight + (maxHeightMobile - baseHeight) * factor;
//     let newScale = baseScale + (maxScaleMobile - baseScale) * factor;

//     logo.style.width = `${newWidth}px`;
//     logo.style.height = `${newHeight}px`;
//     logo.style.transform = `scale(${newScale})`;
//     logo.style.transition = 'width 0.2s ease, height 0.2s ease, transform 0.2s ease';
// }
// document.addEventListener("scroll", () => {
//     const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
//     const scrollHeight = document.documentElement.scrollHeight;
//     const clientHeight = document.documentElement.clientHeight;
//     const header = document.querySelector("header");
//     const logos = document.querySelectorAll(".large_logo_new");

//     logos.forEach(logo => {
//         // Smooth shrink
//         smoothShrink(logo, scrollTop);

//         // ✅ Fix: Reapply logo size at scrollTop === 0
//         if (scrollTop === 0) {
//             setLogoSize(logo, scrollCount);
//         }

//         const logoWidth = logo.getBoundingClientRect().width;

//         // Small / Large class toggle
//         if (logoWidth <= baseWidth + 2) {
//             header.classList.add("small");
//             header.classList.remove("large");
//         } else {
//             header.classList.remove("small");
//             header.classList.add("large");
//         }

//         // ✅ logo_full_width logic
//         if (scrollTop === 0 || scrollTop + clientHeight >= scrollHeight - 5) {
//             header.classList.remove("logo_full_width");
//         } else {
//             if (header.classList.contains("large")) {
//                 header.classList.add("logo_full_width");
//             } else {
//                 header.classList.remove("logo_full_width");
//             }
//         }
//     });
// });




// // Wheel event for desktop to trigger scaling with smoothness
// document.addEventListener("wheel", function (e) {
//     const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
//     if (scrollTop !== 0 || isMobile) return;

//     const logos = document.querySelectorAll(".large_logo_new");

//     if (e.deltaY < 0 && scrollCount < maxScrollCount) {
//         scrollCount++;
//     } else if (e.deltaY > 0 && scrollCount > 0) {
//         scrollCount--;
//     }

//     logos.forEach(logo => setLogoSize(logo, scrollCount));
// });

// // Mobile touch event for scroll
// let touchStartY = 0;
// document.addEventListener("touchstart", function (e) {
//     touchStartY = e.touches[0].clientY;
// }, { passive: true });

// document.addEventListener("touchmove", function (e) {
//     if (!isMobile) return;
//     const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
//     if (scrollTop !== 0) return;

//     const touchEndY = e.touches[0].clientY;
//     const deltaY = touchStartY - touchEndY;
//     const logos = document.querySelectorAll(".large_logo_new");

//     if (deltaY > 10 && scrollCount < maxScrollCount) {
//         scrollCount++;
//         logos.forEach(logo => setLogoSize(logo, scrollCount));
//         touchStartY = touchEndY;
//     } else if (deltaY < -10 && scrollCount > 0) {
//         scrollCount--;
//         logos.forEach(logo => setLogoSize(logo, scrollCount));
//         touchStartY = touchEndY;
//     }
// }, { passive: true });








window.addEventListener("load", () => {
  const header = document.querySelector("header");
  if (!header) return;

  // ✅ Only keep this effect on desktop
  if (window.matchMedia("(max-width: 768px)").matches) return;

  header.classList.add("logo_full_width");
});

window.addEventListener(
  "scroll",
  () => {
    const header = document.querySelector("header");
    if (!header) return;

    // ✅ Only keep this effect on desktop
    if (window.matchMedia("(max-width: 768px)").matches) return;

    if (header.classList.contains("logo_full_width")) {
      header.classList.remove("logo_full_width");
    }
  },
  { passive: true }
);




document.addEventListener("DOMContentLoaded", () => {
  gsap.registerPlugin(ScrollTrigger);

  const textElements = document.querySelectorAll(".text_color_change .rich-text__heading");

  textElements.forEach(textElement => {
    // Wrap each character in a span
    const text = textElement.textContent;
    textElement.innerHTML = text.split("").map(char => `<span>${char}</span>`).join("");

    const chars = textElement.querySelectorAll("span");

    // Animate color on scroll with default starting color
    gsap.fromTo(chars,
      { color: "rgb(206, 153, 102)" }, // Default color
      {
        color: "#57c8df",               // Target color
        scrollTrigger: {
          trigger: textElement.closest(".text_color_change"),
          start: "top 80%",
          end: "bottom 20%",
          scrub: true,
        },
        stagger: 0.05
      }
    );
  });
});

/* =========================
   Mobile header + logo scroll control (Index only)
   - Header height: 160 -> 68 over scroll range
   - Logo padding-top: 50 -> 6 over same range
   - Logotype scales as ONE unit from center (no SVG edits)
   ========================= */
document.addEventListener("DOMContentLoaded", () => {
  if (!document.body.classList.contains("index-template")) return;
  if (!window.matchMedia("(max-width: 768px)").matches) return;

  const svg = document.querySelector("#logssso");
  if (!svg) return;

  const NS = "http://www.w3.org/2000/svg";

  // Wrap logotype into a <g> at runtime
  let gType = svg.querySelector("#fk-logotype-js");
  let gMono = svg.querySelector("#fk-monogram-js");

  if (!gType) {
    gType = document.createElementNS(NS, "g");
    gType.setAttribute("id", "fk-logotype-js");

    gMono = document.createElementNS(NS, "g");
    gMono.setAttribute("id", "fk-monogram-js");

    const children = Array.from(svg.children);
    children.forEach((node) => {
      const tag = (node.tagName || "").toLowerCase();
      if (!tag) return;
      if (["defs", "style", "title", "desc", "metadata"].includes(tag)) return;

      const isMono =
        (node.classList && node.classList.contains("cstm_width_path")) ||
        (node.querySelector && node.querySelector(".cstm_width_path"));

      (isMono ? gMono : gType).appendChild(node);
    });

    // Type first, then monogram on top
    svg.appendChild(gType);
    svg.appendChild(gMono);
  }

  // Center-based scaling for the logotype group
  gType.style.transformBox = "fill-box";
  gType.style.transformOrigin = "center";

  function numVar(el, name, fallback) {
    const v = parseFloat(getComputedStyle(el).getPropertyValue(name));
    return Number.isFinite(v) ? v : fallback;
  }

  // Read tunables from CSS vars
  const headerTop = numVar(document.body, "--header-h-top", 160);
  const headerMin = numVar(document.body, "--header-h-scrolled", 68);

  const ptTop = numVar(document.body, "--logo-pt-top", 50);
  const ptMin = numVar(document.body, "--logo-pt-scrolled", 6);

  const range = numVar(document.body, "--type-scroll-range", 320);
  const start = numVar(document.body, "--type-scroll-start", 0);

  let ticking = false;

  function update() {
    const y = window.scrollY || 0;
    const t = Math.min(1, Math.max(0, (y - start) / range)); // 0..1

    // 1) Logotype scale (as one unit)
    const s = 1 - t; // 1 -> 0
    gType.style.transform = `scale(${s})`;

    // 2) Header height (scroll-based)
    const h = headerTop + (headerMin - headerTop) * t;
    document.documentElement.style.setProperty("--m-header-h", `${h.toFixed(2)}px`);

    // 3) Logo padding-top (scroll-based)
    const pt = ptTop + (ptMin - ptTop) * t;
    document.documentElement.style.setProperty("--m-logo-pt", `${pt.toFixed(2)}px`);

    ticking = false;
  }

  window.addEventListener(
    "scroll",
    () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    },
    { passive: true }
  );

  window.addEventListener("resize", update, { passive: true });

  update();
});



// document.addEventListener("DOMContentLoaded", () => {
//   gsap.registerPlugin(ScrollTrigger);

//   const section = document.querySelector(".index-template .text_color_change");
//   const textElements = section.querySelectorAll(".rich-text__heading");

//   textElements.forEach(textElement => {
//     // Wrap each character in a span
//     const text = textElement.textContent;
//     textElement.innerHTML = text
//       .split("")
//       .map(char => `<span>${char}</span>`)
//       .join("");

//     const chars = textElement.querySelectorAll("span");

//     gsap.fromTo(
//       chars,
//       { color: "rgb(206, 153, 102)" },
//       {
//         color: "#57c8df",
//         stagger: 0.05,
//         scrollTrigger: {
//           trigger: section,
//           start: "top top",
//           end: "+=100%",
//           scrub: true,
//           pin: true,          // 🔥 YAHI FIX KARTA HAI
//           anticipatePin: 1
//         }
//       }
//     );
//   });
// });


// Drawer elements
const contactDrawerBtns = document.querySelectorAll('.contact_us .product-form__submit');
const contactDrawer = document.querySelector('.cstm_product_drawer_contact');
const contactDrawerOverlay = document.querySelector('.login_drawer_dr .engraving_overlay');
const contactcloseDrawerBtn = document.querySelectorAll('.close_drawer');

// Open drawer
contactDrawerBtns.forEach(btn => {
  btn.addEventListener('click', () => {
    contactDrawer?.classList.add('active');
    contactDrawerOverlay?.classList.add('active');
    document.body.classList.add('drawer-open-cstm'); // ✅ ADD BODY CLASS
  });
});

// Close drawer (close button)
contactcloseDrawerBtn.forEach(closebtn => {
  closebtn.addEventListener('click', () => {
    contactDrawer?.classList.remove('active');
    contactDrawerOverlay?.classList.remove('active');
    document.body.classList.remove('drawer-open-cstm'); // ❌ REMOVE BODY CLASS
  });
});

// Close drawer (overlay click)
contactDrawerOverlay?.addEventListener('click', () => {
  contactDrawer?.classList.remove('active');
  contactDrawerOverlay?.classList.remove('active');
  document.body.classList.remove('drawer-open-cstm'); // ❌ REMOVE BODY CLASS
});





// ---------- FIRST DRAWER ----------
const openDrawerBtns = document.querySelectorAll('.open_drawer'); // all first drawer buttons
const engravingDrawer = document.querySelector('.cstm_product_drawer');
const engravingOverlay = document.querySelector('.engraving_overlay');
const closeDrawerBtn = document.querySelector('.close_drawer');

// Open first drawer
openDrawerBtns.forEach(btn => {
  btn.addEventListener('click', () => {
    engravingDrawer?.classList.add('active');
    engravingOverlay?.classList.add('active');
    document.body.classList.add('drawer-open-cstm');
  });
});

// Close first drawer
closeDrawerBtn?.addEventListener('click', () => {
  engravingDrawer?.classList.remove('active');
  engravingOverlay?.classList.remove('active');
  document.body.classList.remove('drawer-open-cstm');
});

engravingOverlay?.addEventListener('click', () => {
  engravingDrawer?.classList.remove('active');
  engravingOverlay?.classList.remove('active');
  document.body.classList.remove('drawer-open-cstm');
});

// ---------- SECOND DRAWER ----------
// ---------- SECOND DRAWER ----------
const openDrawerBtnsNew = document.querySelectorAll('.open_drawersss'); // all second drawer buttons
const engravingDrawerNew = document.querySelector('.cstm_drawer_size');
const engravingOverlaySize = document.querySelector('.size_overlay');
const closeDrawerBtnClose = document.querySelector('.size_close_drawer');

// Open second drawer
document.addEventListener('click', (e) => {
  const target = e.target;
  if (target.classList.contains('open_drawersss')) {
    console.log('Drawer button clicked:', target);
    engravingDrawerNew?.classList.add('active');
    engravingOverlaySize?.classList.add('active');
    document.body.classList.add('drawer-open-cstm');
  }
});


// Close second drawer (cross button)
closeDrawerBtnClose?.addEventListener('click', () => {
  engravingDrawerNew?.classList.remove('active');
  engravingOverlaySize?.classList.remove('active');
  document.body.classList.remove('drawer-open-cstm');
});

// Close second drawer (overlay)
engravingOverlaySize?.addEventListener('click', () => {
  engravingDrawerNew?.classList.remove('active');
  engravingOverlaySize?.classList.remove('active');
  document.body.classList.remove('drawer-open-cstm');
});

// ---------------- Event delegation for inputs ----------------
// Listen on the drawer itself
// Event delegation for inputs (with small delay)
// Function to update all .add_text_size elements
function updateSelectedSize() {
  const selectedInput = engravingDrawerNew?.querySelector('input[type="radio"]:checked');
  if (!selectedInput) return;

  // Update all elements with this class
  document.querySelectorAll('.add_text_size').forEach(el => {
    el.textContent = selectedInput.value;
  });
}

// Run on page load
window.addEventListener('DOMContentLoaded', () => {
  updateSelectedSize();
});

// Update on input click inside drawer
engravingDrawerNew?.addEventListener('click', (event) => {
  const target = event.target;
  if (target.tagName === 'INPUT' && target.type === 'radio') {
    updateSelectedSize();

    // Close drawer after slight delay
    setTimeout(() => {
      engravingDrawerNew.classList.remove('active');
      engravingOverlaySize.classList.remove('active');
      document.body.classList.remove('drawer-open-cstm');
    }, 200);
  }
});







document.addEventListener('DOMContentLoaded', function () {

  const inputField = document.getElementById('LineItemProperty-line_item_property_8mkkKR');
  const hiddenInput = document.getElementById('engraving_hidden_input');

  const submitBtn = document.querySelector('.submit_engraving');
  const editBtn = document.querySelector('.edit_engraving');
  const addEngravingBtn = document.querySelector('.add_engraving_btn');
  const editEngravingBtn = document.querySelector('.edit_engraving_btn');

  if (!inputField || !hiddenInput || !submitBtn || !editBtn) return;

  /* ========= SUBMIT ========= */
  submitBtn.addEventListener('click', () => {

    if (inputField.value.trim() === '') {
      alert('Please enter some text');
      return;
    }

    /* ✅ MOST IMPORTANT FIX */
    hiddenInput.value = inputField.value.trim();

    inputField.disabled = true;
    submitBtn.style.display = 'none';
    editBtn.style.display = 'inline-block';

    if (addEngravingBtn) addEngravingBtn.style.display = 'none';
    if (editEngravingBtn) editEngravingBtn.style.display = 'inline';

    const drawerCloseBtn = document.querySelector('.close_drawer');
    if (drawerCloseBtn) drawerCloseBtn.click();
  });

  /* ========= EDIT ========= */
  editBtn.addEventListener('click', () => {
    inputField.disabled = false;
    editBtn.style.display = 'none';
    submitBtn.style.display = 'inline-block';

    if (addEngravingBtn) addEngravingBtn.style.display = 'inline';
    if (editEngravingBtn) editEngravingBtn.style.display = 'none';

    inputField.focus();
  });

});


document.addEventListener('DOMContentLoaded', function () {

  const deliveryinputField = document.getElementById('delivery_date');
  const deliveryinputhiddenInput = document.getElementById('delivery_date_input');

  const deliveryopenDrawerBtns = document.querySelectorAll('.check_delivery_btn');
  const deliveryinputsubmitBtn = document.querySelector('.delivering_submit_engraving');
  const deliveryinputeditBtn = document.querySelector('.delivering_edit_engraving');

  const deliveryaddEngravingBtn = document.querySelector('.check-delivery-date');
  const deliveryaeditEngravingBtn = document.querySelector('.deliveryedit_engraving_btn');

  const deliveringengravingDrawer = document.querySelector('.delivering_pincode');
  const deliveringengravingOverlay = document.querySelector('.deliveringengraving_overlay');
  const deliveringcloseDrawerBtn = document.querySelectorAll('.close_delivering_pincode');

  const deliveryEstimateText = document.querySelector('.delivery_estimate_text');

  // Safety check
  if (!deliveryinputField || !deliveryinputhiddenInput || !deliveryinputsubmitBtn || !deliveryinputeditBtn) {
    return;
  }

  /* ========= DATE FORMAT FUNCTION ========= */
  function formatDate(date) {
    const day = date.getDate();
    const month = date.toLocaleString('en-IN', { month: 'short' });

    const suffix =
      day % 10 === 1 && day !== 11 ? 'st' :
      day % 10 === 2 && day !== 12 ? 'nd' :
      day % 10 === 3 && day !== 13 ? 'rd' : 'th';

    return `${day}${suffix} ${month}`;
  }

  /* ========= OPEN DRAWER ========= */
  deliveryopenDrawerBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      deliveringengravingDrawer?.classList.add('active');
      deliveringengravingOverlay?.classList.add('active');
      document.body.classList.add('drawer-open-cstm');
    });
  });

  /* ========= SUBMIT ========= */
  deliveryinputsubmitBtn.addEventListener('click', () => {

    const pincode = deliveryinputField.value.trim();

    // 6 digit pincode validation
    if (!/^\d{6}$/.test(pincode)) {
      alert('Please enter a valid 6 digit pincode');
      return;
    }

    // Hidden input value
    deliveryinputhiddenInput.value = pincode;

    deliveryinputField.disabled = true;
    deliveryinputsubmitBtn.style.display = 'none';
    deliveryinputeditBtn.style.display = 'inline-block';

    if (deliveryaeditEngravingBtn) deliveryaeditEngravingBtn.style.display = 'inline';

    /* ========= DELIVERY DATE LOGIC ========= */
    const today = new Date();

    const startDate = new Date(today);
    startDate.setDate(today.getDate() + 20);

    const endDate = new Date(today);
    endDate.setDate(today.getDate() + 25);

    const formattedStart = formatDate(startDate);
    const formattedEnd = formatDate(endDate);

    /* ========= UPDATE TEXT ========= */
    if (deliveryEstimateText) {
      deliveryEstimateText.innerText =
        `Delivering to ${pincode} between ${formattedStart} and ${formattedEnd}`;
      deliveryEstimateText.style.display = 'block';
    }
  });

  /* ========= EDIT ========= */
  deliveryinputeditBtn.addEventListener('click', () => {
    deliveryinputField.disabled = false;
    deliveryinputeditBtn.style.display = 'none';
    deliveryinputsubmitBtn.style.display = 'inline-block';

    if (deliveryaddEngravingBtn) deliveryaddEngravingBtn.style.display = 'flex';
    if (deliveryaeditEngravingBtn) deliveryaeditEngravingBtn.style.display = 'none';

    if (deliveryEstimateText) {
      deliveryEstimateText.style.display = 'none';
    }

    deliveryinputField.focus();
  });

  /* ========= CLOSE DRAWER ========= */
  deliveringcloseDrawerBtn.forEach(closebtn => {
    closebtn.addEventListener('click', () => {
      deliveringengravingDrawer?.classList.remove('active');
      deliveringengravingOverlay?.classList.remove('active');
      document.body.classList.remove('drawer-open-cstm');
    });
  });

});
document.addEventListener('DOMContentLoaded', function () {

  // OPEN POPUP + AUTOPLAY
  document.querySelectorAll('.new_banner_viideo').forEach(function (banner) {
    banner.addEventListener('click', function () {

      const popup = banner.querySelector('.popup_icon');
      const iframe = popup.querySelector('iframe');

      if (!popup || !iframe) return;

      popup.style.display = 'block';

      // autoplay add
      let src = iframe.getAttribute('src');
      if (!src.includes('autoplay=1')) {
        iframe.setAttribute('src', src + (src.includes('?') ? '&' : '?') + 'autoplay=1');
      }
    });
  });


  // CLOSE POPUP + PAUSE VIDEO
  document.querySelectorAll('.popup_icon').forEach(function (popup) {

    const closeBtn = popup.querySelector('.popup-close');
    const iframe = popup.querySelector('iframe');

    if (!closeBtn || !iframe) return;

    const originalSrc = iframe.getAttribute('src').replace('&autoplay=1', '').replace('?autoplay=1', '');

    closeBtn.addEventListener('click', function (e) {
      e.stopPropagation();

      popup.style.display = 'none';

      // video stop
      iframe.setAttribute('src', originalSrc);
    });
  });

});

document.addEventListener('DOMContentLoaded', () => {
  const targetSection = document.querySelector(
    '.sticky_product_add_to_cart'
  );

  const stickyBar = document.querySelector(
    '.sticky-atc-bar.page-width.page-width--full'
  );

  if (!targetSection || !stickyBar) return;

  let lastScrollY = window.scrollY;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const currentScrollY = window.scrollY;

        // Scroll DOWN
        if (
          currentScrollY > lastScrollY &&
          entry.boundingClientRect.top <= 0
        ) {
          stickyBar.classList.add('your-new-class');
        }

        // Scroll UP
        if (currentScrollY < lastScrollY) {
          stickyBar.classList.remove('your-new-class');
        }

        lastScrollY = currentScrollY;
      });
    },
    {
      root: null,
      threshold: 0,
    }
  );

  observer.observe(targetSection);
});




